module.exports = __webpack_public_path__ + "img/obs_camera_simple.720a710c.svg";